<template>
    <div class="row">
        <div class="col-lg-12 col-xl-8">
            <new-pre-order-unit-form
                :manufacturers="manufacturers"
                @searchManufacturers="$emit('searchManufacturers', $event)"
                @addUnit="$emit('addUnit', $event)"
                @cancel="$emit('cancel')"
            />
        </div>
    </div>
</template>
<script>
import NewPreOrderUnitForm from "./NewPreOrderUnitForm.vue";

export default {
    name: "PreOrderUnit",
    components: { NewPreOrderUnitForm },
    props: {
        title: {
            type: String,
            default: "New Pre-Order Unit",
        },
        manufacturers: {
            type: Array,
            required: true,
        },
    },
};
</script>
